import {
  ORDER_REMOVE_LOCATION,
  DROPPING_ANIMATION_START,
  DROPPING_ANIMATION_FINISH,
  FLYING_ANIMATION_START,
  FLYING_ANIMATION_FINISH,
  CLEAN_ORDERS,
  DISABLE_SUBMIT,
} from '../constants/index';

// ACTIONS

const droppingAnimationStartAction = location => ({
  type: DROPPING_ANIMATION_START,
  location,
});

const droppingAnimationFinishAction = () => ({
  type: DROPPING_ANIMATION_FINISH,
});

const flyingAnimationStartAction = () => ({
  type: FLYING_ANIMATION_START,
});

const flyingAnimationFinishAction = () => ({
  type: FLYING_ANIMATION_FINISH,
});

const removeLocationFromOrderAction = locID => ({
  type: ORDER_REMOVE_LOCATION,
  loc_id: locID,
});

const cleanOrdersAction = () => ({
  type: CLEAN_ORDERS,
});

const disableSubmitButton = () => ({
  type: DISABLE_SUBMIT,
});

const getCookie = (name) => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[]\/+^])/g, '\\$1')}=([^;]*)`,
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

const addLocationToOrderCookies = (location) => {
  const newLocationObject = {
    loc_id: location.loc_id,
    position_index: location.position_index,
    name: (location.localized_info) ? location.localized_info.heading : location.address_title,
    link: (location.localized_info) ? location.url : window.location.pathname,
    gategory_for_ga: (location.localized_info) ? location.localized_info.category_for_ga : location.category_for_ga,
  };

  let selectedLocationsCookies = getCookie('selectedLocations');
  let updatedSelectedLocations = [];

  if (selectedLocationsCookies === undefined) {
    selectedLocationsCookies = [];
  } else {
    selectedLocationsCookies = JSON.parse(selectedLocationsCookies);
  }

  selectedLocationsCookies.push(newLocationObject);
  updatedSelectedLocations = encodeURIComponent(JSON.stringify(selectedLocationsCookies));

  document.cookie = `selectedLocations=${updatedSelectedLocations}; path=/`;
};

const cleanOrderCookies = () => {
  document.cookie = 'selectedLocations=[]; path=/';
};

const removeLocationFromOrderCookies = (locID) => {
  const selectedLocationsCookies = JSON.parse(getCookie('selectedLocations'));
  let updatedSelectedLocations = selectedLocationsCookies.filter(location => location.loc_id !== locID);

  updatedSelectedLocations = encodeURIComponent(JSON.stringify(updatedSelectedLocations));

  document.cookie = `selectedLocations=${updatedSelectedLocations}; path=/`;
};

export const removeLocationFromOrder = locID => function (dispatch) {
  dispatch(removeLocationFromOrderAction(locID));
  removeLocationFromOrderCookies(locID);
};

export const droppingAnimationStart = location => function (dispatch) {
  dispatch(droppingAnimationStartAction(location));
};

export const droppingAnimationFinish = () => function (dispatch) {
  dispatch(droppingAnimationFinishAction());
};

export const flyingAnimationStart = () => function (dispatch) {
  dispatch(flyingAnimationStartAction());
};

export const flyingAnimationFinish = location => function (dispatch) {
  addLocationToOrderCookies(location);
  dispatch(flyingAnimationFinishAction());
};

export const cleanOrders = () => function (dispatch) {
  dispatch(cleanOrdersAction());
  cleanOrderCookies();
};

export const disableSubmit = () => function (dispatch) {
  dispatch(disableSubmitButton());
};
